<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
    </window-tab>

    <window-tab title="Data" icon="database">
      <album-select-group v-model="albumId"></album-select-group>
      <table class="table table-bordered table-responsive table-hover table-sm" v-if="pictures && pictures.length">
        <thead>
        <tr>
          <th>Image</th>
          <th>Order</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="picture in pictures">
          <td><img :src="picture.image" :title="picture.fileName"></td>
          <td class="inline-edit">
            <input type="text" class="inline-input form-control" v-model.lazy="orders[picture.pictureId]"
                   @change="updateRecords">
          </td>
        </tr>
        </tbody>
      </table>
    </window-tab>

    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapTemplateData } from '@/utils'
  import * as action from '@/store/action-types'
  import AlbumSelectGroup from '../ui/album-select-group'

  export default {
    components: {AlbumSelectGroup},
    name: 'uiaa-partner-logos',
    mixins: [templateMixin],
    computed: {
      ...mapTemplateData(['albumId']),
      ...mapTemplateData({
        'orders': {type: Object, default: {}}
      }),
      album () {
        return this.$store.getters.album(this.albumId) || {}
      },
      pictures () {
        return this.album.pictures || []
      }
    },
    methods: {
      updateRecords () {
        this.$store.dispatch(action.TEMPLATE_DATA, {
          templateId: this.templateId,
          data: {
            orders: this.orders
          }
        })
        const data = {
          pictures: this.pictures.map(p => {
            return {
              order: this.orders[p.pictureId] || 0,
              imageUrl: p.image
            }
          })
        }
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  td {
    height: 65px;
    text-align: center;
    padding: 0.1rem;
    vertical-align: middle;
  }

  td img {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/uiaa-partner-logos.vue